import { render, staticRenderFns } from "./index_dis.vue?vue&type=template&id=f8742f36&scoped=true"
import script from "./index_dis.vue?vue&type=script&lang=js"
export * from "./index_dis.vue?vue&type=script&lang=js"
import style0 from "./index_dis.vue?vue&type=style&index=0&id=f8742f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8742f36",
  null
  
)

export default component.exports